import { WIDGET_COOKIE_NAME, type WidgetUser } from '@/config';

export default function setWidgetCookie(data: WidgetUser) {
  const value = encodeURIComponent(JSON.stringify(data));
  document.cookie = `${WIDGET_COOKIE_NAME}=${value}; path=/; SameSite=Lax`;
}
